import withCheckPermission from '../../../../../../../shared/check-permission-hoc';

import { enum as permissions } from '../../../../../../../../../../../enums/admin-permissions';
import { enum as payoutStatuses } from '../../../../../../../../../../../enums/payout-statuses';

function PayoutActionCanBeAllowed({ check, action, status, children }) {
	function canBeAllowed() {
		switch (action) {
			case 'change-urgency':
				return (check(permissions.payoutsApprove) || check(permissions.payoutsChangeUrgency)) && (
					status === payoutStatuses.pending || status === payoutStatuses.approved
				);
			case 'reject':
				return check(permissions.payoutsApprove) && (
					status === payoutStatuses.pending || status === payoutStatuses.approved
				);
			case 'approve':
				return check(permissions.payoutsApprove) && status === payoutStatuses.pending;
			case 'confirm':
			case 'partial':
				return check(permissions.payoutsConfirm) && status === payoutStatuses.approved;
			default:
				return true;
		}
	}

	return children(canBeAllowed());
}

export default withCheckPermission(PayoutActionCanBeAllowed);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/table/components/payout-body/components/payout-action-can-be-allowed/index.js